import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMutation } from '@apollo/react-hooks';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Form from 'components/form';
import Input from 'components/form/Input';
import Checkbox from 'components/form/Checkbox';
import Button from 'components/common/Button';
import { updateUser } from 'reducers/user';
import { UPDATE_USER } from 'graphql/Home';
import useSnack  from 'hooks/useSnack';

const { FormItem } = Form;

const OtherSettings = ({ form: { getFieldDecorator, validateFields } }) => {
  const snack = useSnack();
  const user = useSelector((u) => u.user.user);
  const [mutate] = useMutation(UPDATE_USER);
  const dispatch = useDispatch();

  const onSubmit = () => {
    return validateFields().then((values) =>
      mutate({
        variables: {
          data: values,
          sub: user.sub,
        },
      })
        .then(() =>
          dispatch(updateUser(values )),
        )
        .then(() => snack.success('Settings updated'))
        .catch((e) => snack.error(e.message)),
    );
  };

  return (
    <Card>
      <CardContent>
        <Typography paragraph variant="h5">
          Message Auto reply
        </Typography>
        <Form>
          <FormItem>
            {getFieldDecorator('auto_reply_message', {
              initialValue: user.auto_reply_message,
            })(
              <Input
                fullWidth
                multiline
                rows={5}
                label="Auto reply message"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('auto_reply_enabled', {
              initialValue: user.auto_reply_enabled,
              valuePropName: 'checked',
            })(
              <Checkbox
                label="Enable auto reply message"
              />,
            )}
          </FormItem>
          <br/>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            Save
          </Button>
        </Form>
      </CardContent>
    </Card>
  )
};

export default Form.create()(OtherSettings);